import { expressionEnd, expressionStart } from '../common-constants';

export function hasExpression(expressionString: any) {
	if (
		typeof expressionString === 'string' &&
		expressionString.includes(expressionStart) &&
		expressionString.includes(expressionEnd)
	)
		return true;
	return false;
}
